$(document).ready(function() {
             var Existing_pin = localStorage.getItem('ExistPincode');
            $('#pincode_1').val(Existing_pin);
            var average_TAT = localStorage.getItem('TAT');
            if(average_TAT){
                getDeliveryData(average_TAT);

            }
            // $('#checkTat').click(function() {
                $('#pincode_1').keyup(function(){
               
                // Get the entered pincode
                const pincode = $('#pincode_1').val().trim();

                // Check if pincode is entered
                if (pincode<6) {
                    $('#responsemessage').text('Please enter valid Pincode').removeClass('fa success').addClass('error');
                    return;
                }
                else{
                 // Make the API request
                const apiUrl = `https://shopify.wforwoman.com/pincodes/service/${pincode}`;
                $.ajax({
                url: apiUrl,
                method: 'GET',
                dataType: 'json',
                success: function(response) {
                  if (response.success) {
                     const tatMax = response.data.TaTMax;
                     localStorage.setItem('ExistPincode', pincode);
                     localStorage.setItem('TAT', tatMax);
                    // Call the function with tatMax
                     getDeliveryData(tatMax);
        } else {
            $('#responsemessage').text('Pincode Not Servicable');
        }
    },
    error: function() {
        $('#responsemessage').text('Error fetching data. Please ensure the API is working.');
    }
});
}
});
       
        
// Define the function outside the AJAX callback
function getDeliveryData(tatMax) {
    const parsedTatMax = parseInt(tatMax, 10);
    const next_dt = new Date();
    next_dt.setDate(next_dt.getDate() + parsedTatMax);

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const dayNames = [
        "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ];

    const monthName = monthNames[next_dt.getMonth()];
    const dayName = dayNames[next_dt.getDay()];

    // Update the result on the page
    $('#responsemessage').html(
        `<span  class="span2"><u>Free Delivery:</u> <b>${dayName}, ${monthName} ${next_dt.getDate()}</b></span>`
    ).removeClass('error').addClass('fa success');


}
});